export const domainsLogger = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    domainsLoggerBase
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  try {
    await domainsLoggerBase(request);
    return {};
  } catch (error) {
    return {};
  }
};
//# sourceMappingURL=domainsLogger.js.map